import React from 'react';

import {
  Button,
  Grid
} from '@mui/material';
import {
  Form,
  errorUtil,
  fields,
  formUtil
} from 'iron-forge-react-modules';
import {
  useFieldArray,
  useForm
} from 'react-hook-form';

import { BaseWidget } from 'modules/layer01';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.storeId);
  const [saveSoftwareVersions, saveSoftwareVersionsTuple] = dataService.useSaveSoftwareVersions(props.storeId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      softwareVersions: []
    }
  });
  const fieldArray = useFieldArray<types.IFormState>({
    control: form.control,
    name: 'softwareVersions'
  });

  formUtil.useSetFormFields(queryTuple, form.setValue, ['softwareVersions']);

  const processSubmit = React.useCallback(
    (formState: types.IFormState) => {
      errorUtil.errorWrap(async () => {
        await saveSoftwareVersions(formState);
      }, {
        INVALID_ARGS: "Invalid arguments."
      });
    },
    [saveSoftwareVersions]
  );

  const loading = queryTuple.loading || saveSoftwareVersionsTuple.loading;
  return (
    <Form.FC
      disableDefaultOverflow
      onSubmit={form.handleSubmit(processSubmit)}>
      <BaseWidget.FC
        title="Software Versions"
        elAction={(
          <Button
            disabled={loading}
            type="submit">
            Save
          </Button>
        )}>
        <Grid container>
          {fieldArray.fields.map((field, index) => (
            <React.Fragment key={field.id}>
              <Grid
                item
                xs={11}>
                <ControlledTextField
                  isDisabled={loading}
                  formControl={form.control}
                  fieldKey={`softwareVersions.${index}.name`} />
              </Grid>

            </React.Fragment>
          ))}

          <Grid
            item
            xs={12}>
            <Button
              disabled={loading}
              onClick={() => fieldArray.append({
                id: '',
                name: ''
              })}>
              Add Software Version
            </Button>
          </Grid>
        </Grid>
      </BaseWidget.FC>
    </Form.FC>
  );
};
